import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getTopicForPath } from '../content.js';
import HelpDrawer from './HelpDrawer.jsx';

/**
 * The layout's help affordance — a `?` button next to the account chrome
 * (AppNavbar) that opens the in-app help drawer, pre-scrolled to the topic
 * covering whichever page the user is currently on.
 */
export default function HelpWidget({ className = '' }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <div className={className}>
      <button
        type="button"
        className="btn btn-link p-0 border-0 help-widget__trigger"
        aria-label="Open help"
        aria-haspopup="dialog"
        data-testid="help-widget-trigger"
        onClick={() => setOpen(true)}
      >
        <i className="fa fa-question-circle" aria-hidden="true" />
      </button>

      <HelpDrawer
        open={open}
        onClose={() => setOpen(false)}
        initialTopic={getTopicForPath(location.pathname)}
      />
    </div>
  );
}
